import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { footerLinksApi } from '../../config';
import { maintenanceLink } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(private apiService: ApiService) {}

  postSupportRequest(body: object) {
    return this.apiService.post(footerLinksApi.postSupportRequest, body);
  }

  getSupportCategory(param: string) {
    return this.apiService.get(footerLinksApi.getSupportCategory + param);
  }

  getMaintenanceMessage() {
    return this.apiService.get(maintenanceLink.getMaintenanceMessage);
  }

  getBannerWidgetapi() {
    return this.apiService.get(footerLinksApi.getBannerWidgetapi);
  }

  getBanners(queryParams: object) {
    return this.apiService.get(footerLinksApi.getBanner, queryParams as any);
  }

  checkUserCanAccessQuiz() {
    return this.apiService.get(footerLinksApi.checkUserCanAccessQuiz);
  }

  getQuizMetaInfo(id: string) {
    if (parseInt(id) !== parseInt(id))
      return this.apiService.get(footerLinksApi.quizMetaInfoString + id);
    return this.apiService.get(footerLinksApi.quizMetaInfoNumber + id);
  }

  getQuizData(id: string | number) {
    return this.apiService.get(footerLinksApi.quizData + id);
  }

  saveQuizAnswer(params: object) {
    return this.apiService.post(footerLinksApi.saveQuizAnswer, params);
  }

  submitQuiz(params: { id: string | number }) {
    return this.apiService.post(footerLinksApi.submitQuiz + '?id=' + params.id);
  }

  reviewQuiz(params: { quizId: string | number; userId: string | number }) {
    return this.apiService.get(
      footerLinksApi.reviewQuiz + '?quizId=' + params.quizId + '&userId=' + params.userId
    );
  }

  getQuizIDbasedOnDate() {
    return this.apiService.get(footerLinksApi.getQuizId);
  }

  getSliderImages(queryParams: object) {
    return this.apiService.get(
      footerLinksApi.getSliderImages,
      queryParams as any
    );
  }
}
